import type { FC } from "react"

import { studioToScreen, screenToStudio } from "@logic/lib/design"
import { useRecoilValue } from "recoil"

import {
  areaIndex,
  findInsetAreaFacesState,
} from "~/containers/LegacyDesigner/state/elements"
import { zoomState } from "~/containers/LegacyDesigner/state/view"

import { SvgX } from "./InsetAreaFilteringVisualizations"
import { RainbowNodeGroups } from "../Visuals/NodeGroups"
import { RainbowEdgeGroup } from "../Visuals/RainbowEdgeGroupsPlayback"

export const LinkedEdgesVisualization: FC<{ id: string; idx: number }> = ({
  id,
  idx,
}) => {
  const zoom = useRecoilValue(zoomState)
  const domId = `linkedEdges-${id}`
  const {
    procedure: {
      insetsAndLinks,
      linksBetweenInsets,
      intersections = [],
      dividedMeshNodeGroups,
      nodesEliminated,
    },
  } = useRecoilValue(findInsetAreaFacesState(id))

  return (
    <>
      <RainbowEdgeGroup edges={insetsAndLinks} color="cyan" r={5} i={idx} />
      <RainbowEdgeGroup
        edges={linksBetweenInsets.flat()}
        color="#c0f"
        r={4}
        i={idx}
      />
      {intersections.map((p, i) => {
        const point = studioToScreen.point(p, zoom)

        return (
          <g key={domId + `_` + i}>
            <circle cx={point.x} cy={point.y} r={18} fill="#00f" />
            <circle cx={point.x} cy={point.y} r={17} fill="#fff200" />
            <text
              x={point.x}
              y={point.y + 7}
              textAnchor="middle"
              fill="#00f"
              fontSize="3px"
            >
              {p.alphaCode}
            </text>
          </g>
        )
      })}
      <RainbowNodeGroups nodeGroups={dividedMeshNodeGroups} />
      {nodesEliminated.map((node, idx) => (
        <SvgX
          key={String(idx) + `_` + String(node.x) + `_` + String(node.y)}
          node={screenToStudio.point(node, zoom)}
          size={16}
          fill="transparent"
        />
      ))}
    </>
  )
}

export const LinkedEdgesVisualizations: FC = () => {
  const areaIds = useRecoilValue(areaIndex)

  return (
    <>
      {areaIds.map((id, idx) => (
        <LinkedEdgesVisualization key={id + `linkedEdges`} id={id} idx={idx} />
      ))}
    </>
  )
}
